import classNames from 'classnames';
import { FC, MouseEvent } from 'react';
import kiosksStore from '../../store/kiosksStore';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { history } from '~/services/history';
import { TBooleanInNumber } from '~/types/main';
import { confirmDelete } from '~/utils/modalConfirmations';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import DeleteRestoreBlock from '~/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import Text from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  id: string;
  branchName: string;
  status: TBooleanInNumber;
  isDelete: TBooleanInNumber;
  gridTemplate: string;
}

const KioskItem: FC<IProps> = ({ id, branchName, status, isDelete, gridTemplate }): JSX.Element => {
  const onEditKiosk = () => {
    if (isDelete) return;
    history.push(SCREENS.SETTINGS_DEVICES_KIOSKS_EDIT(id));
  };

  const onActionBlockClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const handleStatusChange = (status: TBooleanInNumber) => {
    kiosksStore.updateKioskStatus(id, status);
  };

  const handleDelete = () => {
    confirmDelete({
      title: localeStore.t('delete_kiosk_question'),
      message: localeStore.t('confirm_deleting_kiosk_text'),
      onConfirm: () => kiosksStore.deleteKiosk(id),
      redConfirmBtn: true,
    });
  };

  const handleRestore = () => {
    kiosksStore.restoreKiosk(id);
  };

  return (
    <div onClick={onEditKiosk} className={classNames('kiosk-item mr-4', gridTemplate, { 'cursor-pointer': !isDelete })}>
      <div className="kiosk-item__element">
        <Text type="list-row" text={id} noTranslate />
      </div>

      <div className="kiosk-item__element">
        <Text type="list-row" text={branchName} noTranslate />
      </div>

      <div
        onClick={onActionBlockClick}
        className={classNames('kiosk-item__element cursor-default', isDelete ? 'justify-content-end' : 'justify-content-between')}
      >
        {isDelete ? null : <Switcher status={status} onChange={handleStatusChange} />}
        <DeleteRestoreBlock isDelete={isDelete} iconClassName="mr-4" onDelete={handleDelete} onRestore={handleRestore} />
      </div>
    </div>
  );
};

export default KioskItem;
